import { login, visitor, logout, getInfo, smslogin } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
// import store from '@/store'
// import { MessageBox } from 'element-ui'

// eslint-disable-next-line no-unused-vars
import { set } from 'js-cookie'
import ssoApi from '@/api/sso/sso-api'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  // introduction: '',
  roles: [],
  modules: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  // SET_INTRODUCTION: (state, introduction) => {
  //   state.introduction = introduction
  // },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_MODULES: (state, modules) => {
    state.modules = modules
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

   // 验证码 login
   smslogin({ commit }, userSms) {
    const { username, mobile, verificationCode } = userSms
    return new Promise((resolve, reject) => {
      smslogin({ username: username, mobile: mobile, verificationCode: verificationCode, countryCode: "86" }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  visitor({ commit }) {
    return new Promise((resolve, reject) => {
      visitor().then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // sso login
  ssologin({ commit }, queryCode) {
    return new Promise((resolve, reject) => {
      ssoApi.ssoLogin(queryCode).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response
        // debugger
        if (!data) {
          reject('Verification failed, please Login again.')
          return
        }
        const { roles, name, avatar, modules } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_MODULES', modules)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        localStorage.setItem("roles", roles);
        localStorage.setItem("modules", modules);
        // commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        // debugger
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_MODULES', [])
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_MODULES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
